import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';

export const changePasswordSchema = z
  .object({
    currentPassword: z
      .string()
      .trim()
      .nonempty(VALIDATION_MESSAGES.password.required),
    newPassword: z
      .string()
      .trim()
      .nonempty(VALIDATION_MESSAGES.password.required)
      .min(8, VALIDATION_MESSAGES.password.min)
      .max(20, VALIDATION_MESSAGES.password.max)
      .refine((val) => /[A-Z]/.test(val), {
        message: VALIDATION_MESSAGES.password.uppercase,
      })
      .refine((val) => /[a-z]/.test(val), {
        message: VALIDATION_MESSAGES.password.lowercase,
      })
      .refine((val) => /\d/.test(val), {
        message: VALIDATION_MESSAGES.password.number,
      })
      // eslint-disable-next-line no-useless-escape
      .refine((val) => /[@$!%*?&\[\]#]/.test(val), {
        message: VALIDATION_MESSAGES.password.specialChar,
      }),
    confirmNewPassword: z
      .string()
      .trim()
      .nonempty(VALIDATION_MESSAGES.confirmPassword.required)
      .min(8, VALIDATION_MESSAGES.confirmPassword.min)
      .max(20, VALIDATION_MESSAGES.confirmPassword.max)
      .refine((val) => /[A-Z]/.test(val), {
        message: VALIDATION_MESSAGES.confirmPassword.uppercase,
      })
      .refine((val) => /[a-z]/.test(val), {
        message: VALIDATION_MESSAGES.confirmPassword.lowercase,
      })
      .refine((val) => /\d/.test(val), {
        message: VALIDATION_MESSAGES.confirmPassword.number,
      })
      // eslint-disable-next-line no-useless-escape
      .refine((val) => /[@$!%*?&\[\]#]/.test(val), {
        message: VALIDATION_MESSAGES.confirmPassword.specialChar,
      }),
  })
  .refine((data) => data.newPassword === data.confirmNewPassword, {
    message: VALIDATION_MESSAGES.confirmPassword.match,
    path: ['confirmNewPassword'],
  });

export type TChangePassword = z.infer<typeof changePasswordSchema>;
